<script lang="ts">
	import type { ThemeButtonStyle, ThemeColor, ThemeSize } from './Theme';
	import { classnames } from './util';

	let className = '';
	export { className as class };
	export let active = false;
	export let btnStyle: ThemeButtonStyle | undefined = undefined;
	export let size: ThemeSize | undefined = undefined;
	export let block = false;
	export let wide = false;
	export let loading = false;
	export let hideContentWhileLoading = false;
	export let color: ThemeColor = 'secondary';
	export let submit = false;
	export let disabled = false;
	export let href = '';
	export let id = '';
	export let element = undefined;
	export let innerClasses = '';

	$: ariaLabel = $$props['aria-label'];

	$: classes = classnames(className, 'btn', {
		'btn-active': active,
		// Styles
		'btn-ghost': btnStyle === 'ghost',
		'btn-link': btnStyle === 'link',
		'btn-outline': btnStyle === 'outline',
		'btn-square': btnStyle === 'square',
		'btn-circle': btnStyle === 'circle',
		// Colors
		'btn-primary': color === 'primary',
		'btn-secondary': color === 'secondary',
		'btn-accent': color === 'accent',
		'btn-info': color === 'info',
		'btn-success': color === 'success',
		'btn-warning': color === 'warning',
		'btn-error': color === 'error',
		// Sizes
		'btn-xs': size === 'xs',
		'btn-sm': size === 'sm',
		'btn-lg': size === 'lg',
		'btn-wide': wide,
		'btn-block': block
	});
</script>

{#if href}
	<a
		{...$$restProps}
		class={classes + ' group'}
		disabled={disabled || loading ? true : undefined}
		bind:this={element}
		on:click
		on:mousedown
		{href}
		{id}
		aria-label={ariaLabel}
	>
		{#if loading}
			<span class="loading loading-spinner"></span>
		{/if}
		{#if !(loading && hideContentWhileLoading)}
        <div class="h-[1.75rem] pt-[0.4375rem] overflow-hidden font-medium px-3">
            <div class="h-[0.875rem] mb-[14px] group-hover:-translate-y-[200%] group-hover:duration-500">
                <slot />
            </div>
            
            <div class="h-[0.875rem] group-hover:-translate-y-[200%] group-hover:duration-500">
                <slot />
            </div>
        </div>
		{/if}
	</a>
{:else}
	<button
		{...$$restProps}
		type={submit ? 'submit' : 'button'}
		class={classes + ' group'}
		disabled={disabled || loading ? true : undefined}
		bind:this={element}
		on:click
		on:mousedown
		aria-label={ariaLabel}
	>
		{#if loading}
			<span class="loading loading-spinner"></span>
		{/if}
		{#if !(loading && hideContentWhileLoading)}
        <div class="h-[1.75rem] pt-[0.4375rem] overflow-hidden font-medium px-3 {innerClasses}">
            <div class="h-[0.875rem] mb-[14px] group-hover:-translate-y-[200%] group-hover:duration-500">
                <slot />
            </div>
            
            <div class="h-[0.875rem] group-hover:-translate-y-[200%] group-hover:duration-500">
                <slot />
            </div>
        </div>
		{/if}

	</button>
{/if}
